import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Layers, ArrowRight } from 'lucide-react';
import Reveal from '@/components/Reveal';
import { SERVICES } from '@/data/services';

const ICONS = { 'talent-management': Users, 'digital-production': Layers };

export default function CoreFunctions() {
  return (
    <section id="cores" className="bg-white py-24 lg:py-32">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl mb-14">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#2563EB] mb-4 block">
            The Dual Agency Framework
          </span>
          <h2
            className="font-display font-bold text-[#0B0B0B] tracking-tight leading-tight"
            style={{ fontSize: 'clamp(2rem, 4vw, 3.25rem)' }}
          >
            Our Cores & Functions
          </h2>
          <p className="mt-5 text-[#0B0B0B]/60 text-base lg:text-lg font-light leading-relaxed">
            Two integrated divisions operating under one institutional standard — representation
            at the highest tier, and production capability to match.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.slug];
            return (
              <Reveal key={s.slug} delay={i * 0.12}>
                <Link
                  to={`/services/${s.slug}`}
                  className="group block h-full rounded-lg border border-[#0B0B0B]/10 bg-[#F5F5F5] p-8 lg:p-10 hover:border-[#2563EB] hover:bg-white hover:shadow-[0_20px_60px_-30px_rgba(37,99,235,0.45)] transition-all duration-500"
                >
                  <div className="flex items-start justify-between mb-7">
                    <div className="w-12 h-12 rounded-lg bg-[#0B0B0B] flex items-center justify-center group-hover:bg-[#2563EB] transition-colors duration-500">
                      <Icon className="w-5 h-5 text-white" />
                    </div>
                    <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#0B0B0B]/35">
                      {s.eyebrow}
                    </span>
                  </div>
                  <h3 className="font-display font-bold text-2xl lg:text-3xl text-[#0B0B0B] tracking-tight mb-4">
                    {s.title}
                  </h3>
                  <p className="text-[#0B0B0B]/60 leading-relaxed font-light">{s.summary}</p>

                  <ul className="mt-7 space-y-3 pt-7 border-t border-[#0B0B0B]/10">
                    {s.capabilities.slice(0, 3).map((c) => (
                      <li key={c.title} className="flex items-center gap-3 text-sm text-[#0B0B0B]/75">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#2563EB] shrink-0" />
                        {c.title}
                      </li>
                    ))}
                  </ul>

                  <span className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#2563EB]">
                    Explore this division
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}